import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import NewsflashList from '../../components/DashBoard/CatalogList/NewsflashList'

import Meta from '../../components/Helmet/Meta'
import SideBarComponents from '../../components/SideBar/SideBarComponents'
import './dashboard.css'

const NewsflashListScreendas = () => {
    return (
        <div   className="main"  fluid >
            <Meta
                title=" | Admin Users"
            />
            <Container fluid>
                <Row>
                    <Col md={3}>
                        <h4> </h4>
                    </Col>
                    <Col md={9}>
                        <h4 > liste News-flash </h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SideBarComponents />
                    </Col>
                    <Col md={9}>
                        <NewsflashList />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default NewsflashListScreendas
